import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import {
	setInitialLoginState,
	resendPin,
	setUserType,
} from '../../../redux/userAuthentication/userAuth.actions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import Loader from '../../../utils/Loader';
import FootNote from '../sharedComponents/footNote';
import Login from '../sharedComponents/loginForm';
import SocialLogin from '../sharedComponents/socialLogin';
import '../userAuthenticationStyles.css';
import { trimText, isValidLoginId } from '../../../utils/commonFunctions';
import UserTypes from '../../../utils/userTypes';
const mapStateToProps = (state) => {
	const { loginId, success, userType } = state.rootReducer.loginDetails;
	return {
		loginId,
		error: state.rootReducer.utils.errorPanel,
		success,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		updateState: (value) => dispatch(setInitialLoginState(value)),
		createUser: () => dispatch(resendPin()),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

class SignUp extends Component {
	constructor(props) {
		super(props);
		Loader.hide();
		this.validateName = this.validateName.bind(this);
		this.state = {
			checked: true
		}
		localStorage.setItem('receiveUpdates', this.state.checked)
	}

	componentDidMount() {
		this.props.setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
		const { userType, setUserType } = this.props;

		if (userType !== UserTypes.Junior) {
			setUserType(UserTypes.Junior);
		}
	}

	validateName = () => {
		let { loginId, setErrorPanel, createUser } = this.props;
		loginId = trimText(loginId);
		let panelMsg = isValidLoginId(loginId);
		localStorage.setItem('login_id', loginId);

		if (panelMsg.length > 0) {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg,
			});
			return false;
		} else {
			createUser();
		}

		return true;
	};

	render() {
		const {
			error: { panelClass, panelMsg },
		} = this.props;
		return (
			<div id="wrapper">
				<div className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
					<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
						<form action="" className="form-horizontal step-login-form" method="">
							<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
								<div className="message_box">
									<div className={panelClass}>{panelMsg}</div>
								</div>
								<Login headerText="Register with" hidePin={true} />
								{/* <label for='receiveUpdates' className='receiveUpdates'>
									<input
										type="checkbox"
										name="receiveUpdates"
										id="receiveUpdates"
										value="1"
										onClick={() => { this.setState({ checked: !this.state.checked }); localStorage.setItem('receiveUpdates', !this.state.checked) }}
										checked={this.state.checked}
										style={{ defaultChecked: this.state.checked }}
									/>
									Receive offers and updates on WhatsApp
								</label> */}
								<button
									aria-label="login"
									id="loginBtn"
									type="button"
									className="btn-step-signin btn-primary"
									onClick={this.validateName}
								>
									Create an account
								</button>
								<SocialLogin />
								<div className="pinResetBlock">
									<Link to="/">Existing user?</Link>
								</div>
								<hr />
								<FootNote userActivity="Create an account" />
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(SignUp),
);
//export default compose(connect(mapStateToProps, mapDispatchToProps))(SignUp)
